module.exports = __webpack_public_path__ + "img/emsFA1.1eeb4420.png";